Vendd.Scripts.load(function () {
    var $wrappers = $('.x-control.x-filters');

    $wrappers.each(function (index, wrapper) {

        var $wrapper = $(wrapper);

        var isAjaxLoad = $wrapper.data('ajax-load').toString().toLowerCase().trim() === "true",
            hasSubmitButton = $wrapper.data('submit-button').toString().toLowerCase().trim() === "true",
            documentURL;

        model = null;

        documentURL = document.URL;

        function UpdateProductList(url) {

            var $ajaxPL = $('.x-control.x-list[data-list=' + $wrapper.data('list') + ']').first(),
                ajaxPL = $ajaxPL.get(0);

            //if Ajax Filters call async service with new constracted url  
            if (isAjaxLoad && $ajaxPL.length > 0) {

                var queryString = url.split("?").length > 1 ? "?" + url.split("?")[1] : "";
                var configuration = $('.configuration', ajaxPL).text();

                //change url
                history.pushState({}, '', url);

                Vendd.MessageBus.publishAsync(ajaxPL, new Vendd.ProductList.Messages.GetModel(ajaxPL, configuration, LhApp.Context.Item.Template, queryString, true, wrapper.defaultUriFilter));
            }
            //else refresh page with new constracted url 
            else {
                window.location.href = url;
            }
        }

        function UpdateQueryString(key, value, url) {

            if (!url) url = documentURL;

            // dirty fix for new url rewriter, remove page number to go back to page 1
            url = url.replace(/\/{1}p{1}[0-9]+/, '');

            var re = new RegExp("([?|&])" + key + "=.*?(&|#|$)", "gi");

            if (url.match(re)) {
                if (value) {
                    value = url.replace(re, '$1' + key + "=" + value + '$2');
                } else {
                    value = url.replace(re, '$2');
                }

                if (value.indexOf('?') == -1) { // convert first paramter separator to query params separator
                    var pos = value.indexOf('&');
                    if (pos != -1) // has at least one parameter
                        value = value.substring(0, pos) + '?' + value.substring(pos + 1, value.length);
                }
                return value;
            }
            else {
                if (value) {
                    var separator = url.indexOf('?') !== -1 ? '&' : '?',
                        hash = url.split('#');
                    url = hash[0] + separator + key + '=' + value;

                    if (hash[1]) url += '#' + hash[1];

                    return url;
                } else {
                    return url;
                }
            }
        };

        function getQueryStringValueByName(name) {
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(documentURL);
            if (results == null)
                return "";
            else
                return decodeURIComponent(results[1].replace(/\+/g, " "));
        };

        function removeValueFromCommaSeparatedString(list, value, separator) {
            separator = separator || ",";
            var values = list.split(separator);
            for (var i = 0; i < values.length; i++) {
                if (values[i] == value.replace(/\s+/g, '-')) {
                    values.splice(i, 1);
                    return values.join(separator);
                }
            }
            return list;
        };

        function getInputFilterValues($rangeInputFilter) {

            var $control = $rangeInputFilter ? $rangeInputFilter : $('.x-control[data-control="filter"][data-type="range-input"]', $wrapper);

            $control.each(function (i, rangeFilter) {

                var $filter = $(rangeFilter);
                var $inputFrom = $('.input-from', $filter);
                var valFrom = $inputFrom.val() ? parseFloat($inputFrom.val()) : null;
                var $inputTo = $('.input-to', $filter);
                var valTo = $inputTo.val() ? parseFloat($inputTo.val()) : null;
                var tempValueFrom;
                var queryName, queryValue, urlWithItem;

                //if both inputs are empty -> return
                if (valFrom == null && valTo == null)
                    return;

                //set valFrom with default minimum value
                if (valFrom == null && valTo)
                    valFrom = parseFloat($filter.data('min'));

                //set valTo with default maximum value
                if (valTo == null && valFrom)
                    valTo = parseFloat($filter.data('max'));

                //reverse values if valFrom is bigger
                if (valFrom && valTo && (valFrom > valTo)) {
                    tempValueFrom = valFrom;
                    valFrom = valTo;
                    valTo = tempValueFrom;
                }

                if (valFrom) {
                    queryName = $filter.data('filter-key') + '-from';
                    queryValue = valFrom;
                    //update querystring
                    urlWithItem = UpdateQueryString(queryName, queryValue, documentURL);
                    documentURL = urlWithItem;
                }

                if (valTo) {
                    queryName = $filter.data('filter-key') + '-to';
                    queryValue = valTo;
                    //update querystring
                    urlWithItem = UpdateQueryString(queryName, queryValue, documentURL);
                    documentURL = urlWithItem;
                }
            });
        }

        function initSliderFilters() {
            $('.x-control[data-control="filter"][data-type="range"]', $wrapper).each(function (i, rangeFilter) {

                var $filter = $(rangeFilter);
                var $slider = $filter.find('*[data-slider]');
                var $init = $filter.find('*[data-init]');
                var $text = $filter.find('input[data-text]');
                var key = $filter.data('filter-key');

                var urlMask = $init.data('mask');
                urlMask = urlMask.split('?')[1];
                var textMask = $text.data('mask');

                var symbol = $init.data('symbol');

                var minValue = parseFloat($init.data('min'));
                var maxValue = parseFloat($init.data('max'));
                var currentMinValue = parseFloat($init.data('from'));
                var currentMaxValue = parseFloat($init.data('to'));
                var step = parseFloat($init.data('step'));
                var rangeDisabled = false, fromMax = 0, toMin = 0;

                if (maxValue - minValue <= step) {
                    rangeDisabled = true;
                    fromMax = minValue;
                    toMin = maxValue;
                } else {
                    if (currentMinValue < minValue || currentMinValue > maxValue) {
                        currentMinValue = minValue;
                    }

                    if (currentMaxValue < minValue || currentMaxValue > maxValue) {
                        currentMaxValue = maxValue;
                    }

                    if (currentMaxValue < currentMinValue) {
                        currentMinValue = minValue;
                        currentMaxValue = maxValue;
                    }

                    fromMax = currentMaxValue - step;
                    toMin = currentMinValue + step;
                }

                $slider.ionRangeSlider({
                    type: "double",
                    grid: true,
                    min: minValue,
                    max: maxValue,
                    from: currentMinValue,
                    to: currentMaxValue,
                    from_max: fromMax,
                    to_min: toMin,
                    block: rangeDisabled,
                    postfix: symbol,
                    skin: "flat",
                    step: step,
                    hide_min_max: true,
                    onChange: function (data) {
                        $text.val(textMask.replace("((from))", data.from).replace("((to))", data.to));
                    },
                    onFinish: function (data) {
                        var queryName;

                        queryName = $(data.input).closest('.x-filter-range-slider').data('filter-key') + '-from';
                        documentURL = UpdateQueryString(queryName, data.from, documentURL);
                        queryName = $(data.input).closest('.x-filter-range-slider').data('filter-key') + '-to';
                        documentURL = UpdateQueryString(queryName, data.to, documentURL);

                        if (!hasSubmitButton) UpdateProductList(documentURL);
                    }
                });

                $text.val(textMask.replace("((from))", $slider.data("from")).replace("((to))", $slider.data("to")));

            });
        }

        function initFilters() {
            var filterKey, searchid, searchList;

            //click filter functionality
            $(".filters .filter ul.filters-list li a", $wrapper).click(function (e) {
                e.preventDefault();

                var itemswithvalue, itemswithoutvalue, urlWithItem, urlWithoutItem;
                var queryName = $(this).attr("data-query");
                var queryValue = $(this).attr("data-value");
                var items = getQueryStringValueByName(queryName);

                $(".filters", $wrapper).addClass('x-loading');

                if (venddProjectConfigs.FilterScrollMobileEnabled)
                    saveFiltersState($(this).closest('.filter'));

                if ($(this).hasClass("checked")) {

                    if ($(this).closest('.filter').hasClass('multi-select')) {
                        $(this).removeClass("checked icon-check").addClass('icon-empty');
                    }
                    $(this).removeClass("checked");

                    itemswithoutvalue = removeValueFromCommaSeparatedString(items, queryValue);
                    urlWithoutItem = UpdateQueryString(queryName, itemswithoutvalue, documentURL);
                    documentURL = urlWithoutItem;
                } else {

                    if ($(this).closest('.filter').hasClass('multi-select')) {
                        $(this).addClass("icon-check").removeClass('icon-empty');
                    } else if ($(this).closest('.filter').hasClass('unique-select')) {
                        items = '';
                        $(this).closest("li").siblings().find('a').removeClass("checked");
                    }
                    $(this).addClass("checked");

                    itemswithvalue = items == '' ? queryValue : items + ',' + queryValue;
                    urlWithItem = UpdateQueryString(queryName, itemswithvalue, documentURL);
                    documentURL = urlWithItem;
                }

                if (!hasSubmitButton) UpdateProductList(documentURL);

                $(".filters", $wrapper).removeClass('x-loading');
            });

            //search filter functionality
            if (!isTouch()) {
                $(".js-scrollbar", $wrapper).mCustomScrollbar({
                    scrollbarPosition: "outside",
                    scrollInertia: 400,
                    theme: "dark-2",
                    mouseWheel: { preventDefault: true }
                });
            }
            
            $('.filters .filter.search', $wrapper).each(function () {
                filterKey = $(this).data('filter-key');
                searchid = filterKey + '-search-id';

                var options = {
                    valueNames: [filterKey]
                };

                searchList = new List(searchid, options);

                searchList.on('updated', function (list) {
                    if (list.matchingItems.length > 0) {
                        $('.no-result').hide();
                    } else {
                        $('.no-result').show();
                    }
                });
            });

            //date filter functionality
            $(".js-datefilter .js-apply-Filter-button", $wrapper).click(function () {
                var filterwrap = this.closest('.js-datefilter');
                var mask = $('.js-datefilterUrlMask', filterwrap)[0].value;
                var dateFrom = $('.js-datefilterdateFrom', filterwrap)[0].value;
                var dateTo = $('.js-datefilterdateTo', filterwrap)[0].value;
                mask = mask.replace("(date-from)", dateFrom).replace("(date-to)", dateTo).replace("(tag),", "");
                UpdateProductList(mask);
            });

            //submit specific filter
            $(".js-submit-range-filter", $wrapper).click(function (e) {
                e.preventDefault();

                //get specific filter
                var $rangeInputFilter = $(this).closest('.x-control[data-control="filter"][data-type="range-input"]');
                //get input values
                var $inputFrom = $('.input-from', $rangeInputFilter);
                var valFrom = $inputFrom.val() ? parseFloat($inputFrom.val()) : null;
                var $inputTo = $('.input-to', $rangeInputFilter);
                var valTo = $inputTo.val() ? parseFloat($inputTo.val()) : null;
                //if both inputs are empty -> return
                if (valFrom == null && valTo == null)
                    return;

                getInputFilterValues($rangeInputFilter);
                UpdateProductList(documentURL);
            });

            //submit filters
            $(".js-submit-filters", $wrapper).click(function (e) {
                e.preventDefault();
                //get input values
                getInputFilterValues();
                UpdateProductList(documentURL);
                //close pop up in mobile
                if (isAjaxLoad && (isTouch() && $(window).width() < 960)) {
                    wrapper.close();
                }
            });

            //clear all applied filters
            $(".js-clear-all-filter", $wrapper).click(function (e) {
                e.preventDefault();

                var searchParam = getQueryStringValueByName('search-for');

                if (searchParam) {
                    var url = (documentURL || "").split('?')[0];
                    url += '?search-for=' + searchParam;
                    documentURL = url;
                    UpdateProductList(documentURL);
                }
                else {
                    //retain old functionality
                    documentURL = documentURL.split('?')[0];
                    UpdateProductList(documentURL);
                }

            });

            //clear applied filter
            $(".js-clear-filter", $wrapper).click(function () {

                var queryName, queryValue, items, itemswithoutvalue, urlWithoutItem;

                if ($(this).hasClass('range')) {
                    //remove from-value from url
                    queryName = $(this).attr("data-query") + '-from';
                    queryValue = parseFloat($(this).attr("data-from")).toString();
                    items = getQueryStringValueByName(queryName);
                    itemswithoutvalue = removeValueFromCommaSeparatedString(items, queryValue);
                    urlWithoutItem = UpdateQueryString(queryName, itemswithoutvalue, documentURL);
                    //update document url
                    documentURL = urlWithoutItem;

                    //remove to-value from url
                    queryName = $(this).attr("data-query") + '-to';
                    queryValue = parseFloat($(this).attr("data-to")).toString();
                    items = getQueryStringValueByName(queryName);
                    itemswithoutvalue = removeValueFromCommaSeparatedString(items, queryValue);
                    urlWithoutItem = UpdateQueryString(queryName, itemswithoutvalue, documentURL);
                    //update document url
                    documentURL = urlWithoutItem;
                } else {
                    //remove value from url
                    queryName = $(this).attr("data-query");
                    queryValue = $(this).attr("data-value");
                    items = getQueryStringValueByName(queryName);
                    itemswithoutvalue = removeValueFromCommaSeparatedString(items, queryValue);
                    urlWithoutItem = UpdateQueryString(queryName, itemswithoutvalue, documentURL);
                    //update document url
                    documentURL = urlWithoutItem;
                }

                UpdateProductList(documentURL);
            });

            //function for expand/collapse filters
            expandFilters();

            //function for open/close filters
            toggleFilters();

            //function for show/hide more filters
            seeMoreToggle(6);
        }

        function toggleFilters() {
            var iconOpen = $wrapper.data('icon-open');
            var iconClose = $wrapper.data('icon-close');

            wrapper.open = function () {
                if ($wrapper.hasClass('with-popup')) {
                    $('.header-overlay').addClass('visible');
                    $('html, body').addClass('no-scroll');
                }
                $('.js-filter-toggle-btn', $wrapper).removeClass(iconOpen).addClass(iconClose + ' active');
                $wrapper.addClass('opened');
            };

            wrapper.close = function () {
                $('.js-filter-toggle-btn', $wrapper).removeClass(iconClose + ' active').addClass(iconOpen);
                $wrapper.removeClass('opened');
                if ($wrapper.hasClass('with-popup')) {
                    $('html, body').removeClass('no-scroll');
                    $('.header-overlay').removeClass('visible');
                }
            };

            $wrapper.off('click', '.js-filter-toggle-btn').on('click', '.js-filter-toggle-btn', function (e) {
                e.preventDefault();
                var $this = $(this);

                if ($this.hasClass('active')) {
                    wrapper.close();
                } else {
                    wrapper.open();
                }
            });

            if ($wrapper.hasClass('with-toggle')) {
                $(document).on('click', function (e) {
                    if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                        wrapper.close();
                    }
                });
            }

            if ($wrapper.hasClass('with-popup')) {
                $wrapper.on('click', '.js-close-filters, .js-close-ajax-filters', function (e) {
                    e.preventDefault();
                    wrapper.close();
                });

                $('.header-overlay').on('click', function (e) {
                    e.preventDefault();
                    wrapper.close();
                });

                $(window).resize(_.debounce(function () {
                    if ($(window).width() >= 960) {
                        wrapper.close();
                    }
                }, 50));
            }
        }

        function expandFilters() {
            $(".filters .filter", $wrapper).children('.title').addClass('icon-arrow-down');
            $(".filters .filter.expanded", $wrapper).children('.title').addClass('icon-arrow-up');

            $(".filters .filter .title", $wrapper).click(function () {
                if ($(this).parent().hasClass("disabled")) return;
                if ($(this).parent().hasClass("expanded")) {
                    $(this).parent().removeClass("expanded");
                    $(this).removeClass('icon-arrow-up').addClass('icon-arrow-down');
                } else {
                    $(this).parent().addClass("expanded");
                    $(this).removeClass('icon-arrow-down').addClass('icon-arrow-up');
                }
            });
        }

        function initFilterExpander() {
            if ($(window).width() < 960) {
                if (!$wrapper.hasClass('mobile')) {
                    closeExpandedFilters();
                    $wrapper.addClass('mobile');
                }
            } else {
                if ($wrapper.hasClass('mobile')) {
                    $('.filter', $wrapper).addClass('expanded').find('.title').removeClass('icon-arrow-down').addClass('icon-arrow-up');
                    $wrapper.removeClass('mobile');
                }
            }
        }

        function closeExpandedFilters() {
            $('.filter.expanded', $wrapper).removeClass('expanded').find('.title').removeClass('icon-arrow-up').addClass('icon-arrow-down');
            $wrapper.addClass('mobile');

            if ($wrapper.hasClass('with-toggle') && $wrapper.hasClass('opened')) {
                $('.js-filter-toggle-btn', $wrapper).addClass('active');
                $('.js-filter-toggle-btn', $wrapper).removeClass('icon-arrow-down').addClass('icon-arrow-up');
            }
        }

        function seeMoreToggle(columnSize) {
            $('.filters .filter.simple.see-more').each(function () {
                var multiplier = $(this).hasClass('two-columns') ? 2 : 1;

                if ($(this).find('.filters-list').children('li').length > (columnSize * multiplier)) {
                    $(this).find(".show-more").addClass('visible');
                }
            });
            $(".filter-toggle-btn").click(function () {
                if ($(this).hasClass('show-more'))
                    $(this).removeClass('show-more icon-arrow-down').addClass('show-less icon-arrow-up').closest('.filter').addClass('show-all');
                else {
                    $(this).removeClass('show-less icon-arrow-up').addClass('show-more icon-arrow-down').closest('.filter').removeClass('show-all');
                }
            });
        }

        function saveFiltersState(filter) {

            if (!isTouch() || $(window).width() > 960)
                return;

            Cookies.set("OpenedFilter", filter.data('filter-key'), { samesite: 'Lax' });
        }

        function openFiltersAfterReload() {

            if (!isTouch() || $(window).width() > 960)
                return;

            var filterKey = Cookies.get("OpenedFilter");
            var headerHeight = $('.header-region').height();
            var filtersScroll;

            if (filterKey) {
                var openedFilter = $(".filters .filter[data-filter-key='" + filterKey + "']", $wrapper);
                $('.js-filter-toggle-btn', $wrapper).trigger('click');
                openedFilter.children('.title').trigger('click');
                Cookies.remove("OpenedFilter", { path: '/' });
                filtersScroll = setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: openedFilter.offset().top - headerHeight
                    }, 300);
                }, 2000);
            }

            $(window).scroll(function () {
                clearTimeout(filtersScroll);
            });
        }

        wrapper.loading = function loading(loading) {
            if (loading) {
                $wrapper.addClass('x-loading');
            } else {
                $wrapper.removeClass('x-loading');
            }
        };

        wrapper.update = function update() {
            wrapper.loading(true);

            //update filters
            var filters = Vendd.Handlebars.parse("filters", model.Filters);
            $wrapper.html(filters);

            $('.js-close-ajax-filters', $wrapper).text(model.Products.ItemsCountText);

            wrapper.bind();

            wrapper.loading(false);
        };

        wrapper.bind = function bind() {
            initSliderFilters();

            initFilters();

            //close expanded filters
            if ($(window).width() < 960) closeExpandedFilters();

            $(window).resize(_.debounce(function () { initFilterExpander(); }, 50));

            if (venddProjectConfigs.FilterScrollMobileEnabled)
                openFiltersAfterReload();
        };

        wrapper.bind();

        Vendd.MessageBus.subscribe(Vendd.ProductList.Messages.GetModelSuccess, wrapper, function (envelope) {
            model = envelope.message.data.data;
            wrapper.update();
        });

        //issue for serialize of Handlebar.NET(sync) & JS Handlebars (async) for rangeFilter.html
        Handlebars.registerHelper('serialize', function (context) {
            return (context);
        });

        //reload the page on back browser
        window.addEventListener('popstate', function () {
            if (($('.product-list-page').length > 0 || $('.search-products-page').length > 0) && isAjaxLoad) {
                location.reload();
            }
        }, false);
    });

});

